// ============================================================
// CV 数据文件 —— 只需编辑这里，网页自动更新
// ============================================================

export const cvData = {

  // ── 基本信息 ──────────────────────────────────────────────
  name: "Linge (Caroline) LI",
  address: "Nöthnitzer Str. 38, 01187 Dresden",
  email: "carolinge@pks.mpg.de",
  researchGate: "https://www.researchgate.net/profile/Linge-Li-4",
  googleScholar: "https://scholar.google.com/citations?user=V979NzsAAAAJ",
  github: "https://github.com/Carolinge",

  // ── 教育经历 ──────────────────────────────────────────────
  education: [
    {
      date: "2019.9 – 2025.6",
      degree: "Ph.D. Physical Chemistry",
      institution: "University of Science and Technology of China (USTC) · Hefei",
      detail: "National Lab for Physical Sciences at Microscale",
    },
    {
      date: "2015.9 – 2019.6",
      degree: "B.S. Chemistry",
      institution: "University of Science and Technology of China (USTC) · Hefei",
      detail: "Department of Chemistry",
    },
  ],

  // ── 科研经历 ──────────────────────────────────────────────
  research: [
    {
      date: "2025 – present",
      role: "Postdoctoral Researcher · MPI-PKS",
      institution: "Intracellular condensates · Advisor: Prof. Frank Jülicher",
      bullets: [
        "Theoretical framework for controlling electric potential in biomolecular condensates",
        "Uncovering general mechanisms by which protein flexible regions regulate condensation behavior",
      ],
    },
    {
      date: "2024 – 2025",
      role: "Visiting PhD · MPI-PKS / CBG",
      institution: "Intracellular condensates · Advisors: Prof. Frank Jülicher, Prof. Anthony Hyman",
      bullets: [
        "Developed theoretical models to predict pH gradients in coexisting liquid phases at chemical equilibrium",
        "Applied multiscale simulations to characterize condensation mechanism of protein homomers",
      ],
    },
    {
      date: "2019 – 2025",
      role: "Ph.D. Candidate · USTC",
      institution: "Intracellular condensates & aerogel self-assembly · Advisor: Prof. Zhonghuai Hou",
      bullets: [
        "Developed multiscale modeling protocol of LLPS development (Biophys. Rep. 2022)",
        "Application of multiscale protocol in biological condensate systems: microtubule end-binding protein EB1 (Nat. Cell Biol. 2023); role of dimethylarginines in stress granule scaffolds (J. Biol. Macromol. 2024); amyloid fiber stability analysis (Aggregates 2025)",
        "General modulation effect of IDP conformation on liquid-liquid phase behavior (J. Phys. Chem. B. 2023)",
        "Developed NMR data-driven CG force field for temperature-dependent HSF1 phase separation (Nat. Chem. Biol. 2025)",
        "Applied DFT calculation and molecular dynamics to guide aerogel syntheses (Small 2021)",
      ],
    },
    {
      date: "2017 – 2019",
      role: "Undergraduate Research · USTC",
      institution: "Organic Synthesis · Advisor: Prof. Zhiyong Wang",
      bullets: [
        "Synthetic methodologies of vinyl sulfones via Cu(I)-catalyzed terminal-alkyne functionalization with excellent chemo- and stereoselectivity (Org. Lett. 2018, Sci. China Chem. 2019)",
      ],
    },
  ],

  // ── 发表论文 ──────────────────────────────────────────────
  // highlight: true  → 高亮显示（代表作）
  // ‖ 标记共同一作
  publications: [
    {
      journal: "Aggregates · 2025",
      title: "Bridging Mechanical Properties with Atomic Structures of Polymorphic α-Synuclein Fibrils by Single-Molecule Analysis and Molecular Dynamics Simulations",
      authors: "Bi, L.‖, Li, L.‖, Li, X.‖, Wu, S., Zhang, X., Zhao, Y., Li, D., Liu, C., Hou, Z., Sun, B.",
      url: "https://doi.org/10.1002/agt2.70023",
      highlight: false,
    },
    {
      journal: "Nat. Chem. Biol. · 2025",
      title: "The molecular mechanism of temperature-dependent phase separation of heat shock factor 1",
      authors: "Ren, Q.‖, Li, L.‖, Li, J., Shi, C., Sun, Y., Yao, X., Hou, Z., Xiang, S.",
      url: "https://www.nature.com/articles/s41589-024-01806-y",
      highlight: true,
    },
    {
      journal: "Int. J. Biol. Macromol. · 2024",
      title: "PRMT1 and TDRD3 promote stress granule assembly by rebuilding the protein–RNA interaction network",
      authors: "Qin, M.‖, Fan, W.‖, Li, L.‖, Xu, T., Zhang, H., et al. · 277, 134411",
      url: "https://doi.org/10.1016/j.ijbiomac.2024.134411",
      highlight: false,
    },
    {
      journal: "J. Phys. Chem. B · 2023",
      title: "Crosslink-Induced Conformation Change of Intrinsically Disordered Proteins Has Nontrivial Effect on Phase Separation Dynamics and Thermodynamics",
      authors: "Li, L., Hou, Z. · 127(22), 5018–5026",
      url: "https://pubs.acs.org/doi/10.1021/acs.jpcb.3c01728",
      highlight: true,
    },
    {
      journal: "Nat. Cell Biol. · 2023",
      title: "Phase separation of EB1 guides microtubule plus-end dynamics",
      authors: "Song, X., Yang, F., Yang, F., Wang, Y., Ding, M., Li, L., et al. · 25(1), 79–91",
      url: "https://www.nature.com/articles/s41556-022-01033-4",
      highlight: false,
    },
    {
      journal: "Biophysics Reports · 2022",
      title: "Theoretical modelling of liquid–liquid phase separation: from particle-based to field-based simulation",
      authors: "Li, L., Hou, Z. · 8(2), 55–67",
      url: "http://www.biophysics-reports.org/en/article/doi/10.52601/bpr.2022.210029",
      highlight: false,
    },
    {
      journal: "Small · 2021",
      title: "A Metallic-Ion-Induced Self-Assembly Enabling Nanowire-Based Aerogels",
      authors: "Shang, Q. G.‖, Wang, K.‖, Li, L.‖, He, Z., Jiang, H., Zhu, J., Liu, J. · 17(44), 21034068",
      url: "https://onlinelibrary.wiley.com/doi/10.1002/smll.202170231",
      highlight: false,
    },
    {
      journal: "Chem. Eur. J. · 2021",
      title: "Stereoselective Copper-Catalyzed Direct Aldol Reaction of β,γ-Unsaturated α-Ketoesters with Coumaran-3-Ones",
      authors: "Li, K., Sun, X., Li, L., et al. · 27, 581–584",
      url: "https://chemistry-europe.onlinelibrary.wiley.com/doi/10.1002/chem.202003510",
      highlight: false,
    },
    {
      journal: "Sci. China Chem. · 2019",
      title: "Copper-catalyzed 1,1-difunctionalization of terminal alkynes: a three-component reaction for the construction of vinyl sulfones",
      authors: "Sun, Q., Li, L., et al. · 62, 904–908",
      url: "https://doi.org/10.1007/s11426-019-9454-8",
      highlight: false,
    },
    {
      journal: "Org. Lett. · 2018",
      title: "Copper-Catalyzed Geminal Difunctionalization of Terminal Alkynes by Splitting Sulfonyl Hydrazones into Two Parts",
      authors: "Sun, Q., Li, L., et al. · 20(18), 5592–5596",
      url: "https://pubs.acs.org/doi/10.1021/acs.orglett.8b02268",
      highlight: false,
    },
  ],

  // ── 受邀报告 ──────────────────────────────────────────────
  // 字段：venue（会议/机构）/ title（报告标题，页面上加粗）/ award / location
  invitedTalks: [
    {
      venue: "UNNC Conference on Applied Mathematics and Mathematical Biology",
      title: "Multiscale Theoretical Modeling of Biomolecular Condensates: Two Case Studies",
      award: null,
      location: "Sep 2026, Ningbo",
    },
    {
      venue: "Raff Lab, University of Oxford",
      title: "Multiscale Theoretical Modeling of Liquid–Liquid Phase Separation",
      award: null,
      location: "Apr 2025, Oxford",
    },
    {
      venue: "ITP Seminar, Leibniz Institute of Polymer Research Dresden",
      title: "Multiscale Modeling of LLPS in Heat Shock Factor (HSF1)",
      award: null,
      location: "Nov 2024, Dresden",
    },
  ],

  // ── 学术报告（口头） ──────────────────────────────────────
  conferences: [
    {
      venue: "Workshop on Computer Simulation and Theory of Macromolecules",
      title: "Tuning pH with Phase Separation and Chemical Control via Thermodynamic Programming",
      award: null,
      location: "Apr 2026, Hünfeld",
    },
    {
      venue: "Droplet Meeting, MPI-CBG",
      title: "Tunable pH Differences Between Coexisting Liquid Phases from Thermodynamic Design",
      award: null,
      location: "Mar 2026, Dresden",
    },
    {
      venue: "Academic Conference of the Interdisciplinary Center, USTC",
      title: "热激蛋白 HSF1 的相分离机制多尺度模拟",
      award: null,
      location: "May 2025, Hefei",
    },
    {
      venue: "Droplet Meeting, MPI-CBG",
      title: "Probing the Mechanistic Driving Forces of Globular Protein Condensation via Multiscale Simulation",
      award: null,
      location: "Apr 2025, Dresden",
    },
    {
      venue: "National Conference on Soft Matter and Biological Physics",
      title: "Effect of Crosslink-induced Conformation Change on Phase Behavior and Dynamics",
      award: "Outstanding Oral Presentation",
      location: "Apr 2024, Xi'an",
    },
    {
      venue: "English Academic Forum of HFLN",
      title: "Multiscale Modeling of Liquid–Liquid Phase Separation",
      award: null,
      location: "Jun 2022, Hefei",
    },
  ],

  // ── 海报 ──────────────────────────────────────────────────
  posters: [
    {
      venue: "Nature Conference on Biological Colloids and Condensates",
      title: "Phase Separation and pH Differences in Chemically Reacting Systems",
      award: "Poster Award",
      location: "Sep 2026, Wuhan",
    },
    {
      venue: "EMBL Symposium – Cellular Mechanisms Driven by Phase Separation",
      title: "Phase Separation in Chemically Reacting Systems with Charged Components",
      award: null,
      location: "May 2026, Heidelberg",
    },
    {
      venue: "DPG Meeting 2026",
      title: "Phase Separation in Chemically Reacting Systems Controls Cross-Phase pH Difference",
      award: null,
      location: "Mar 2026, Dresden",
    },
    {
      venue: "Physical Biology Circle Meeting",
      title: "Electric Potential Difference Across Phases Controlled by Liquid–Liquid Phase Separation",
      award: null,
      location: "Jan 2025, Lisbon",
    },
    {
      venue: "EMBL Symposium – Cellular Mechanisms Driven by Phase Separation",
      title: "A Multiscale Theoretical Insight into Temperature-Dependent LLPS of HSF1",
      award: null,
      location: "May 2024, Heidelberg",
    },
    {
      venue: "3rd National Conference on Biological Condensates",
      title: "Multiscale Coarse-Grained Modeling Protocol for Liquid–Liquid Phase Separation",
      award: "Best Poster",
      location: "Jun 2023, Shanghai",
    },
    {
      venue: "Chinese Chemical Society Conference on Soft Matter Theory, Computation and Simulation (SMART)",
      title: "Theoretical Insights into Liquid–Liquid Phase Separation: A Multiscale Protocol and Its Application",
      award: null,
      location: "2023, Changchun",
    },
  ],

  // ── 教学 ──────────────────────────────────────────────────
  teaching: [
    "Teaching Assistant, University Physics Laboratory · USTC, Spring 2018",
    "Teaching Assistant, Basic Organic Chemistry Experiments · USTC, Autumn 2018",
    "Teaching Assistant, Organic Chemistry · USTC, Spring 2019",
    "Teaching Assistant, Analytical Chemistry · USTC, Autumn 2019",
    "Teaching Assistant, Basic Inorganic Chemistry Experiments · USTC, Autumn 2020",
    "Assistant Class Advisor, Department of Chemistry · USTC, 2021 – 2023",
  ],

  // ── 奖学金与荣誉 ──────────────────────────────────────────
  awards: [
    "Outstanding Student Scholarship — Bronze Prize (2017), Gold Prize (2018)",
    "Hefei National Research Center Ph.D. Studentship Award First Prize (¥100,000) · 2019",
    "Dragon Interdisciplinary Research Scholarship · 2024",
  ],

  // ── 方法（页面上已撤下，内容保留备用）────────────────────
  // // ── 方法 ──────────────────────────────────────────────────
  // // 原来是「Theory & Simulation / Software / Programming」三栏表格。
  // // 看了同领域几个人的主页（Takaki 的 CV 根本没有 Skills 一节；
  // // Pappu、Weber、Mittag 都是把方法写进研究描述里），改成
  // // 一句话 + 按角色分行的内联标签，不再是三张小表。
  // methods: {
  //   summary:
  //     "I build the model that a question needs, at whichever resolution it needs, " +
  //     "and check it against experiment rather than against intuition.",
  //   groups: [
  //     {
  //       label: "Theory",
  //       items: ["Statistical physics", "Polymer theory", "Flory–Huggins & field-theoretic simulation", "Non-equilibrium thermodynamics"],
  //     },
  //     {
  //       label: "Simulation",
  //       items: ["Coarse-grained MD", "All-atom MD", "Steered MD", "Kinetic Monte Carlo", "Phase-field", "DFT"],
  //     },
  //     {
  //       label: "Model building",
  //       items: ["Multiscale coarse-graining", "Force-field parameterisation against NMR", "Slab method for phase diagrams"],
  //     },
  //     {
  //       label: "Tooling",
  //       items: ["LAMMPS", "GROMACS", "VASP", "Gaussian", "GPU & HPC", "Python / C++ / Mathematica"],
  //     },
  //   ],
  // },
};
